interface SafeAreaProviderProps {
  children: React.ReactNode;
}

export const SafeAreaProvider = ({ children }: SafeAreaProviderProps) => {
  // Capacitor 8 SystemBars injects and updates Android safe-area variables.
  // iOS continues to use the browser/Ionic safe-area environment values.
  return <>{children}</>;
};
